import React, { createContext, useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";

const GuidedModeContext = createContext();

export const GuidedModeProvider = ({ children }) => {
  const { makeAuthenticatedApiCall } = useContext(AuthContext);
  const [guidedMode, setGuidedMode] = useState(null);
  const [showGuidedModeDialog, setGuidedModeDialog] = useState(false);
  const [guidedModeLoading, setGuidedModeLoading] = useState(true);

  const showOrHideGuidedMode = (value) => {
    setGuidedModeDialog(value);
  };

  const getGuidedModeData = async () => {
    setGuidedModeLoading(true);
    const response = await makeAuthenticatedApiCall(
      "get",
      `/api/userservice/getGuidedMode`,
      {}
    );
    if (response?.status === 200) {
      setGuidedMode(response.data.guidedMode);
    }
    setGuidedModeLoading(false);
    return response;
  };
  const handleSwitchChange = async (input) => {
    let isModeProvided;
    if (input?.target) {
      isModeProvided = input.target.checked;
    } else {
      isModeProvided = input;
    }
    setGuidedMode(isModeProvided);
    const response = await makeAuthenticatedApiCall(
      "post",
      `/api/userservice/updateGuidedMode`,
      {
        guidedMode: isModeProvided,
      }
    );
    return response;
  };

  return (
    <GuidedModeContext.Provider
      value={{
        showGuidedModeDialog,
        guidedMode,
        guidedModeLoading,
        handleSwitchChange,
        showOrHideGuidedMode,
        refreshGuidedMode: getGuidedModeData,
      }}
    >
      {children}
    </GuidedModeContext.Provider>
  );
};

export const useGuidedMode = () => useContext(GuidedModeContext);
